// extracted by mini-css-extract-plugin
module.exports = {"sections":"style_sections__wYv-F"};